import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CheckCheck } from "lucide-react";
import { endpoints } from "@/lib/api";

export function NotificationBell({ testid = "notification-bell", align = "left" }) {
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const nav = useNavigate();

  const load = () => endpoints.notifications().then((r) => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    const close = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const openItem = async (n) => {
    if (!n.read) await endpoints.readNotification(n.id).catch(() => {});
    setOpen(false);
    load();
    if (n.link) nav(n.link);
  };
  const readAll = async () => { await endpoints.readAllNotifications().catch(() => {}); load(); };

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => { setOpen(!open); if (!open) load(); }} className="relative p-1.5 text-white/60 hover:text-gold transition-colors" data-testid={testid} aria-label="Notifications">
        <Bell size={17} />
        {data.unread > 0 && (
          <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-[#C5A059] text-black text-[9px] font-bold flex items-center justify-center" data-testid={`${testid}-count`}>
            {data.unread > 9 ? "9+" : data.unread}
          </span>
        )}
      </button>
      {open && (
        <div className={`absolute ${align === "right" ? "right-0" : "left-0"} top-9 z-[60] w-80 max-h-[420px] overflow-y-auto rounded-md shadow-2xl`}
          style={{ background: "#0B1530", border: "1px solid rgba(197,160,89,0.3)" }} data-testid={`${testid}-panel`}>
          <div className="flex items-center justify-between px-4 py-3 border-b border-white/5">
            <span className="overline text-[9px] text-gold">Notifications</span>
            {data.unread > 0 && <button onClick={readAll} className="text-[11px] text-white/50 hover:text-gold flex items-center gap-1" data-testid={`${testid}-read-all`}><CheckCheck size={12} /> Mark all read</button>}
          </div>
          {!data.items.length && <div className="px-4 py-6 text-[12px] text-white/40 text-center">No notifications yet.</div>}
          {data.items.map((n) => (
            <button key={n.id} onClick={() => openItem(n)} className="w-full text-left px-4 py-3 border-b border-white/5 hover:bg-white/[0.03] transition-colors" data-testid={`notification-${n.id.slice(0, 8)}`}>
              <div className="flex items-start gap-2">
                {!n.read && <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#C5A059] shrink-0" />}
                <div className={n.read ? "pl-3.5" : ""}>
                  <div className="text-[12.5px] text-white">{n.title}</div>
                  <div className="text-[11.5px] text-white/50 mt-0.5">{n.body}</div>
                  <div className="text-[10px] text-white/30 mt-1 font-mono">{String(n.created_at).slice(0, 16).replace("T", " ")}</div>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
